import { Injectable } from '@angular/core'
import {
  ACCOUNTING_ACCOUNT_ADMIN,
  ACCOUNTING_ACCOUNT_READ,
  ACCOUNTING_CHARGE_ADMIN,
  ACCOUNTING_LICENSE_ADMIN,
  ACCOUNTING_PERMISSION_ADMIN,
  ACCOUNTING_VOUCHER_ADMIN,
  AGENT_ADMIN,
  ASSET_ADMIN,
  CERTIFICATE_ADMIN,
  CHINA_ADMIN,
  CLAIM_ADMIN,
  CLAIM_SUBSIDIARY,
  CLAIM_REASON_ADMIN,
  CLAIM_WHITELIST_ADMIN,
  COMPANY_ADMIN,
  ORGANIZATION_ADMIN,
  ORGANIZATION_READ,
  ORGANIZATION_SUBSIDIARY,
  CONFIGURATION_ADMIN,
  CUSTOMER_ADMIN,
  DOCUMENT_ADMIN,
  ENVELOPE_ADMIN,
  EQUIPMENT_ADMIN,
  EXPORT_ADMIN,
  FACILITY_ADMIN,
  FEEDBACK_ADMIN,
  INGEST_ADMIN,
  PID_ADMIN,
  PRODUCT_ADMIN,
  PRODUCTION_WEEK_import,
  SEARCH_ADMIN,
  SPARE_PART_ADMIN,
  SPARE_PART_MAPPING_ADMIN,
  SPARE_PART_REQUEST_ADMIN,
  STOCKLEVEL_import,
  THING_TEMPLATE_ADMIN,
  TRACE_ADMIN
} from '@mybitzer/core/auth/roles'
import { IMenuService, Menu, MenuAction, MenuActionGroup } from '@mybitzer/core/home/menu.api'
import { Observable, of } from 'rxjs'

const CATALOG_ITEMS: MenuAction[] = [
  { id: 0, url: 'product', name: 'menu.product', icon: 'inventory_2', rank: 0, roles: [PRODUCT_ADMIN], status: undefined },
  { id: 0, url: 'document', name: 'menu.document', icon: 'description', rank: 1, roles: [DOCUMENT_ADMIN], status: undefined },
  { id: 0, url: 'certificate', name: 'menu.certificate', icon: 'license', rank: 2, roles: [CERTIFICATE_ADMIN], status: undefined },
  { id: 0, url: 'asset', name: 'menu.asset', icon: 'web_asset', rank: 3, roles: [ASSET_ADMIN], status: undefined }
]

const SPARE_PART_ITEMS: MenuAction[] = [
  { id: 0, url: 'sparepart/item', name: 'menu.spare_part', icon: 'precision_manufacturing', rank: 0, roles: [SPARE_PART_ADMIN], status: undefined },
  { id: 0, url: 'sparepart/bom', name: 'menu.spare_part_bom', icon: 'widgets', rank: 1, roles: [SPARE_PART_ADMIN], status: undefined },
  { id: 0, url: 'sparepart/structure', name: 'menu.spare_part_structure', icon: 'schema', rank: 2, roles: [SPARE_PART_ADMIN], status: undefined },
  { id: 0, url: 'sparepart/bill-of-material', name: 'menu.bill_of_material', icon: 'receipt_long', rank: 3, roles: [SPARE_PART_ADMIN], status: undefined },
  { id: 0, url: 'sparepart-request', name: 'menu.spare_part_request', icon: 'support_agent', rank: 4, roles: [SPARE_PART_REQUEST_ADMIN], status: undefined },
  { id: 0, url: 'sparepart/mapping', name: 'menu.spare_part_mapping', icon: 'link', rank: 5, roles: [SPARE_PART_MAPPING_ADMIN], status: undefined }
]

const CUSTOMER_ITEMS: MenuAction[] = [
  { id: 0, url: 'company', name: 'menu.company', icon: 'domain', rank: 0, roles: [COMPANY_ADMIN], status: undefined },
  { id: 0, url: 'customer', name: 'menu.customer', icon: 'person', rank: 1, roles: [CUSTOMER_ADMIN], status: undefined },
  { id: 0, url: 'organization', name: 'menu.organization', icon: 'corporate_fare', rank: 2, roles: [ORGANIZATION_READ, ORGANIZATION_ADMIN, ORGANIZATION_SUBSIDIARY], status: undefined },
  { id: 0, url: 'member', name: 'menu.member', icon: 'manage_accounts', rank: 3, roles: [ORGANIZATION_READ, ORGANIZATION_ADMIN, ORGANIZATION_SUBSIDIARY], status: undefined }
]

const SUPPORT_ITEMS: MenuAction[] = [
  { id: 0, url: 'inquiry', name: 'menu.inquiry', icon: 'record_voice_over', rank: 0, roles: [FEEDBACK_ADMIN], status: undefined },
  { id: 0, url: 'feedback', name: 'menu.feedback', icon: 'feedback', rank: 1, roles: [FEEDBACK_ADMIN], status: undefined },
  { id: 0, url: 'claim', name: 'menu.claim', icon: 'assignment', rank: 2, roles: [CLAIM_ADMIN, CLAIM_SUBSIDIARY], status: undefined },
  { id: 0, url: 'claim-reason', name: 'menu.claim_reason', icon: 'rule', rank: 3, roles: [CLAIM_REASON_ADMIN], status: undefined },
  { id: 0, url: 'claim-whitelist', name: 'menu.claim_whitelist', icon: 'playlist_add_check', rank: 4, roles: [CLAIM_WHITELIST_ADMIN], status: undefined },
  { id: 0, url: 'export', name: 'menu.export', icon: 'file_export', rank: 5, roles: [EXPORT_ADMIN], status: undefined }
]

const ACCOUNTING_ITEMS: MenuAction[] = [
  { id: 0, url: 'accounting/account', name: 'account.title', icon: 'account_balance', rank: 0, roles: [ACCOUNTING_ACCOUNT_ADMIN, ACCOUNTING_ACCOUNT_READ], status: undefined },
  { id: 0, url: 'accounting/charge', name: 'charge_entry.title', icon: 'assignment', rank: 1, roles: [ACCOUNTING_CHARGE_ADMIN], status: undefined },
  { id: 0, url: 'accounting/license', name: 'license.title', icon: 'class', rank: 2, roles: [ACCOUNTING_LICENSE_ADMIN], status: undefined },
  { id: 0, url: 'accounting/voucher', name: 'voucher.title', icon: 'redeem', rank: 3, roles: [ACCOUNTING_VOUCHER_ADMIN], status: undefined },
  { id: 0, url: 'accounting/permission', name: 'permission.title', icon: 'admin_panel_settings', rank: 4, roles: [ACCOUNTING_PERMISSION_ADMIN], status: undefined }
]

const COMMERCE_ITEMS: MenuAction[] = [
  { id: 0, url: 'stock-level', name: 'menu.stock_level', icon: 'upload_file', rank: 0, roles: [STOCKLEVEL_import], status: undefined },
  { id: 0, url: 'config', name: 'menu.config', icon: 'construction', rank: 1, roles: [CONFIGURATION_ADMIN], status: undefined }
]

const OPERATIONS_ITEMS: MenuAction[] = [
  { id: 0, url: 'facility', name: 'menu.facility', icon: 'factory', rank: 0, roles: [FACILITY_ADMIN], status: undefined },
  { id: 0, url: 'ingest', name: 'menu.ingest', icon: 'sync_alt', rank: 1, roles: [INGEST_ADMIN], status: undefined },
  { id: 0, url: 'production-week', name: 'menu.production_week', icon: 'analytics', rank: 2, roles: [PRODUCTION_WEEK_import], status: undefined },
  { id: 0, url: 'product-config', name: 'menu.product_config', icon: 'bookmark', rank: 3, roles: [PID_ADMIN], status: undefined },
  { id: 0, url: 'envelope', name: 'menu.envelope', icon: 'activity_zone', rank: 4, roles: [ENVELOPE_ADMIN], status: undefined },
  { id: 0, url: 'equipment', name: 'menu.equipment', icon: 'precision_manufacturing', rank: 5, roles: [EQUIPMENT_ADMIN], status: undefined }
]

const ADMIN_ITEMS: MenuAction[] = [
  { id: 0, url: 'search', name: 'menu.search', icon: 'manage_search', rank: 0, roles: [SEARCH_ADMIN], status: undefined },
  { id: 0, url: 'thing-template', name: 'menu.thing_template', icon: 'linked_services', rank: 1, roles: [THING_TEMPLATE_ADMIN], status: undefined },
  { id: 0, url: 'china', name: 'menu.china', icon: 'cloud_upload', rank: 2, roles: [CHINA_ADMIN], status: undefined },
  { id: 0, url: 'trace', name: 'menu.trace', icon: 'speed', rank: 3, roles: [TRACE_ADMIN], status: undefined }
]

const AGENT_ITEMS: MenuAction[] = [
  { id: 0, url: 'agent-setting', name: 'menu.agent_setting', icon: 'smart_toy', rank: 0, roles: [AGENT_ADMIN], status: undefined },
  { id: 0, url: 'tool-definition', name: 'menu.tool_definition', icon: 'build', rank: 1, roles: [AGENT_ADMIN], status: undefined },
  { id: 0, url: 'conversation', name: 'menu.conversation', icon: 'forum', rank: 2, roles: [AGENT_ADMIN], status: undefined }
]

const MENU_GROUPS: MenuActionGroup[] = [
  { id: 1, name: 'menu.group.catalog', rank: 0, actions: CATALOG_ITEMS },
  { id: 2, name: 'menu.group.spare_part', rank: 1, actions: SPARE_PART_ITEMS },
  { id: 3, name: 'menu.group.customers', rank: 2, actions: CUSTOMER_ITEMS },
  { id: 4, name: 'menu.group.support', rank: 3, actions: SUPPORT_ITEMS },
  { id: 5, name: 'menu.group.accounting', rank: 4, actions: ACCOUNTING_ITEMS },
  { id: 6, name: 'menu.group.commerce', rank: 5, actions: COMMERCE_ITEMS },
  { id: 7, name: 'menu.group.operations', rank: 6, actions: OPERATIONS_ITEMS },
  { id: 8, name: 'menu.group.admin', rank: 7, actions: ADMIN_ITEMS },
  { id: 9, name: 'menu.group.agent', rank: 8, actions: AGENT_ITEMS }
]

@Injectable({
  providedIn: 'root'
})
export class MenuService implements IMenuService {
  getMenu(): Observable<Menu> {
    return of({ id: 1, name: 'Menu', priority: 1, groups: MENU_GROUPS })
  }
}
